import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Traditional planners are built for linear brains',
    desc: 'They just give you a longer list of things to feel guilty about.'
  }, {
    title: '"Eat the Frog" advice doesn\'t work',
    desc: 'When your brain perceives the "frog" as a physical threat, it triggers a shutdown.'
  }, {
    title: 'Breaking tasks into "smaller steps" fails',
    desc: 'It often just creates more cognitive noise and more opportunities to get distracted.'
  }, {
    title: 'Using adrenaline and caffeine as "focus fuel"',
    desc: 'Eventually leads to adrenal fatigue and 3 AM insomnia.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-[#112240]" data-id="element-25">
      <div className="max-w-4xl mx-auto animate-fade-in-up delay-200" data-id="element-26">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#F1F5F9] mb-12" data-id="element-27">
          Why What You've Tried Didn't Work
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-28">
          {failures.map((item, index) => <div key={index} className="bg-[#1A2F4A] p-6 rounded-xl border border-[#0B1A2E] flex items-start gap-4 transition-transform hover:-translate-y-1" data-id="element-29">
              <XCircleIcon className="w-6 h-6 text-[#ef4444] shrink-0 mt-1" data-id="element-30" />
              <div data-id="element-31">
                <h3 className="text-[#F1F5F9] font-semibold mb-2" data-id="element-32">
                  {item.title}
                </h3>
                <p className="text-[#94A3B8] text-sm leading-relaxed" data-id="element-33">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}